import { NgModule } from '@angular/core';

import { ResetPasswordComponent } from './reset-password.component';
import { TokenVerificationFailedComponent } from './components/token-verification-failed/token-verification-failed.component';
import { OtpVerifyComponent } from './components/otp-verify/otp-verify.component';
import { updatePasswordComponent } from './components/update-password/update-password.component';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CommonItemsModule } from 'src/common-items/common-items.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { ResetPasswordService } from './services/reset-password.service';
import { ResetPasswordApiService } from './services/reset-password-api.service';
import { SucessPageComponent } from './components/sucess-page/sucess-page.component';

@NgModule({
  declarations: [
    ResetPasswordComponent,
    TokenVerificationFailedComponent,
    OtpVerifyComponent,
    updatePasswordComponent,
    SucessPageComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    CommonItemsModule
  ],
  providers: [ResetPasswordService, ResetPasswordApiService]
})
export class ResetPasswordModule { }